/**
 * KET Vocabulary - School and Education Theme (123 words)
 */
import { KETWord } from './index';

export const schoolEducationWords: KETWord[] = [
  { word: 'teacher', meaning: '老师', example: 'My teacher is very kind.' },
  { word: 'student', meaning: '学生', example: 'I am a student.' },
  { word: 'pupil', meaning: '小学生', example: 'There are thirty pupils in my class.' },
  { word: 'classmate', meaning: '同学', example: 'Tom is my classmate.' },
  { word: 'school', meaning: '学校', example: 'I go to school every day.' },
  { word: 'classroom', meaning: '教室', example: 'The classroom is big.' },
  { word: 'library', meaning: '图书馆', example: 'I read books in the library.' },
  { word: 'playground', meaning: '操场', example: 'We play on the playground.' },
  { word: 'canteen', meaning: '食堂', example: 'We eat lunch in the canteen.' },
  { word: 'gym', meaning: '体育馆', example: 'We have PE in the gym.' },
  { word: 'laboratory', meaning: '实验室', example: 'We do experiments in the laboratory.' },
  { word: 'office', meaning: '办公室', example: 'The teacher is in the office.' },
  { word: 'subject', meaning: '科目', example: 'My favorite subject is English.' },
  { word: 'English', meaning: '英语', example: 'I study English every day.' },
  { word: 'maths', meaning: '数学', example: 'I like maths.' },
  { word: 'science', meaning: '科学', example: 'We have science on Monday.' },
  { word: 'history', meaning: '历史', example: 'I find history interesting.' },
  { word: 'geography', meaning: '地理', example: 'We learn about countries in geography.' },
  { word: 'music', meaning: '音乐', example: 'I play the piano in music class.' },
  { word: 'art', meaning: '美术', example: 'I like drawing in art class.' },
  { word: 'PE', meaning: '体育', example: 'We run in PE class.' },
  { word: 'computer studies', meaning: '计算机课', example: 'I like computer studies.' },
  { word: 'book', meaning: '书', example: 'I read books every day.' },
  { word: 'textbook', meaning: '教科书', example: 'Open your textbook to page 10.' },
  { word: 'notebook', meaning: '笔记本', example: 'I write in my notebook.' },
  { word: 'pen', meaning: '钢笔', example: 'I write with a pen.' },
  { word: 'pencil', meaning: '铅笔', example: 'I use a pencil for math.' },
  { word: 'pencil case', meaning: '铅笔盒', example: 'My pencils are in my pencil case.' },
  { word: 'rubber', meaning: '橡皮', example: 'Can I use your rubber?' },
  { word: 'eraser', meaning: '橡皮', example: 'I need an eraser.' },
  { word: 'ruler', meaning: '尺子', example: 'Draw a line with a ruler.' },
  { word: 'sharpener', meaning: '卷笔刀', example: 'I need a sharpener.' },
  { word: 'scissors', meaning: '剪刀', example: 'Use scissors to cut the paper.' },
  { word: 'glue', meaning: '胶水', example: 'We need glue for this project.' },
  { word: 'paper', meaning: '纸', example: 'I need some paper.' },
  { word: 'page', meaning: '页', example: 'Open your book to page 5.' },
  { word: 'dictionary', meaning: '字典', example: 'I look up words in the dictionary.' },
  { word: 'map', meaning: '地图', example: 'Look at the map.' },
  { word: 'blackboard', meaning: '黑板', example: 'The teacher writes on the blackboard.' },
  { word: 'whiteboard', meaning: '白板', example: 'We use the whiteboard.' },
  { word: 'board', meaning: '板', example: 'Look at the board.' },
  { word: 'chalk', meaning: '粉笔', example: 'The teacher uses chalk.' },
  { word: 'marker', meaning: '马克笔', example: 'Write with a marker.' },
  { word: 'calculator', meaning: '计算器', example: 'I use a calculator in math.' },
  { word: 'computer', meaning: '电脑', example: 'We use computers in class.' },
  { word: 'laptop', meaning: '笔记本电脑', example: 'The teacher has a laptop.' },
  { word: 'tablet', meaning: '平板电脑', example: 'Some students use tablets.' },
  { word: 'study', meaning: '学习', example: 'I study English every day.' },
  { word: 'learn', meaning: '学习', example: 'I learn new words.' },
  { word: 'read', meaning: '读', example: 'I read books.' },
  { word: 'write', meaning: '写', example: 'Please write your name.' },
  { word: 'listen', meaning: '听', example: 'Listen to the teacher.' },
  { word: 'speak', meaning: '说', example: 'Speak in English.' },
  { word: 'talk', meaning: '谈话', example: 'Don\'t talk in class.' },
  { word: 'answer', meaning: '回答', example: 'Please answer the question.' },
  { word: 'ask', meaning: '问', example: 'Ask your teacher.' },
  { word: 'understand', meaning: '理解', example: 'I understand the lesson.' },
  { word: 'know', meaning: '知道', example: 'I know the answer.' },
  { word: 'think', meaning: '思考', example: 'Think about the question.' },
  { word: 'remember', meaning: '记住', example: 'Remember to do your homework.' },
  { word: 'forget', meaning: '忘记', example: 'I forgot my book.' },
  { word: 'repeat', meaning: '重复', example: 'Please repeat that.' },
  { word: 'practice', meaning: '练习', example: 'Practice speaking English.' },
  { word: 'revise', meaning: '复习', example: 'I revise for tests.' },
  { word: 'test', meaning: '测试', example: 'We have a test tomorrow.' },
  { word: 'exam', meaning: '考试', example: 'I am nervous about the exam.' },
  { word: 'pass', meaning: '通过', example: 'I hope to pass the exam.' },
  { word: 'fail', meaning: '不及格', example: 'I don\'t want to fail.' },
  { word: 'mark', meaning: '分数', example: 'What mark did you get?' },
  { word: 'grade', meaning: '成绩', example: 'I got a good grade.' },
  { word: 'score', meaning: '得分', example: 'What was your score?' },
  { word: 'homework', meaning: '作业', example: 'I do my homework after school.' },
  { word: 'exercise', meaning: '练习', example: 'Do exercise 3 on page 10.' },
  { word: 'task', meaning: '任务', example: 'This is a difficult task.' },
  { word: 'project', meaning: '项目', example: 'We are doing a project about animals.' },
  { word: 'assignment', meaning: '作业', example: 'The assignment is due tomorrow.' },
  { word: 'composition', meaning: '作文', example: 'Write a composition about your family.' },
  { word: 'essay', meaning: '文章', example: 'I wrote an essay about my holiday.' },
  { word: 'report', meaning: '报告', example: 'I wrote a report about my favorite animal.' },
  { word: 'presentation', meaning: '展示', example: 'I gave a presentation in class.' },
  { word: 'lesson', meaning: '课', example: 'We have six lessons today.' },
  { word: 'class', meaning: '课', example: 'I am in Class 4.' },
  { word: 'period', meaning: '课时', example: 'We have English in period 2.' },
  { word: 'break', meaning: '休息', example: 'We have a break at 10am.' },
  { word: 'lunchtime', meaning: '午餐时间', example: 'We eat at lunchtime.' },
  { word: 'timetable', meaning: '课程表', example: 'Check the timetable.' },
  { word: 'schedule', meaning: '日程表', example: 'My schedule is busy.' },
  { word: 'term', meaning: '学期', example: 'This term is very short.' },
  { word: 'semester', meaning: '学期', example: 'The semester ends in June.' },
  { word: 'holiday', meaning: '假期', example: 'We have a holiday next week.' },
  { word: 'vacation', meaning: '假期', example: 'I enjoyed my vacation.' },
  { word: 'start', meaning: '开始', example: 'School starts at 8am.' },
  { word: 'finish', meaning: '结束', example: 'School finishes at 4pm.' },
  { word: 'begin', meaning: '开始', example: 'The class begins at 9am.' },
  { word: 'end', meaning: '结束', example: 'The lesson ends at 10am.' },
  { word: 'arrive', meaning: '到达', example: 'I arrive at school at 7:30.' },
  { word: 'leave', meaning: '离开', example: 'I leave school at 4pm.' },
  { word: 'go to school', meaning: '去上学', example: 'I go to school by bus.' },
  { word: 'come to school', meaning: '来学校', example: 'I come to school every day.' },
  { word: 'rule', meaning: '规则', example: 'We have many school rules.' },
  { word: 'behave', meaning: '表现', example: 'You must behave well in class.' },
  { word: 'pay attention', meaning: '注意', example: 'Pay attention to the lesson.' },
  { word: 'be quiet', meaning: '安静', example: 'Please be quiet.' },
  { word: 'stand up', meaning: '站起来', example: 'Stand up, please.' },
  { word: 'sit down', meaning: '坐下', example: 'Sit down, please.' },
  { word: 'put up your hand', meaning: '举手', example: 'Put up your hand to answer.' },
  { word: 'can', meaning: '能', example: 'I can speak English.' },
  { word: 'cannot', meaning: '不能', example: 'I cannot swim.' },
  { word: 'easy', meaning: '容易的', example: 'This test is easy.' },
  { word: 'difficult', meaning: '困难的', example: 'The question is difficult.' },
  { word: 'hard', meaning: '难的', example: 'This homework is hard.' },
  { word: 'interesting', meaning: '有趣的', example: 'The book is interesting.' },
  { word: 'boring', meaning: '无聊的', example: 'The film was boring.' },
  { word: 'important', meaning: '重要的', example: 'English is important.' },
  { word: 'useful', meaning: '有用的', example: 'This dictionary is useful.' },
  { word: 'correct', meaning: '正确的', example: 'Your answer is correct.' },
  { word: 'wrong', meaning: '错误的', example: 'This answer is wrong.' },
  { word: 'right', meaning: '正确的', example: 'That\'s right!' },
  { word: 'education', meaning: '教育', example: 'Education is important.' },
  { word: 'knowledge', meaning: '知识', example: 'Books give us knowledge.' },
  { word: 'skill', meaning: '技能', example: 'Reading is an important skill.' },
  { word: 'college', meaning: '学院', example: 'I want to go to college.' },
  { word: 'university', meaning: '大学', example: 'My sister is at university.' },
];